import React, { lazy } from 'react';

import { Route, Routes } from 'react-router-dom';

import { DetectionServiceApiProvider } from '@apis/detection-service/detection-service-api-provider';

const DetectionListPage = lazy(
  () => import('./detection-list/detection-list.page'),
);

const DetectionDetailsPage = lazy(
  () => import('./detection-details/detection-details.page'),
);

export const DetectionCatalogRoutes = () => {
  return (
    <DetectionServiceApiProvider>
      <Routes>
        <Route index element={<DetectionListPage />} />
        <Route path="/:detectionId" element={<DetectionDetailsPage />} />
      </Routes>
    </DetectionServiceApiProvider>
  );
};
